/**
* Feature Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Feature Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'feature-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.feature-marquee .splide-top' ).length ) {
        $( '.feature-marquee .splide-top' ).each( function( index, element ) {
          new Splide( $( element )[0], {
            type: 'loop',
            fixedWidth: `400px`,
            focus: 'center',
            arrows: false,
            direction: 'rtl',
            pagination: false,
            gap: '2rem',
            speed: 400,
          } ).mount( {AutoScroll} );
        } );
      }
      if ( $( '.feature-marquee .splide-bottom' ).length ) {
        $( '.feature-marquee .splide-bottom' ).each( function( index, element ) {
          new Splide( $( element )[0], {
            type: 'loop',
            fixedWidth: `400px`,
            focus: 'center',
            arrows: false,
            direction: 'ltr',
            pagination: false,
            gap: '2rem',
            speed: 400,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'feature-marquee', COMPONENT );
} )( app );
